/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
const style = {
    'pre[class*="language-"]': {
        color: '#d4d4d4',
        fontSize: 'var(--font-size-code)',
        fontWeight: 'var(--font-weight-normal)',
        letterSpacing: '0',
        lineHeight: '1.25rem',
        textShadow: 'none',
        fontFamily: 'var(--font-font-family-code), monospace',
        direction: 'ltr',
        textAlign: 'left',
        whiteSpace: 'pre',
        wordSpacing: 'normal',
        wordBreak: 'normal',
        MozTabSize: '4',
        OTabSize: '4',
        tabSize: '4',
        WebkitHyphens: 'none',
        MozHyphens: 'none',
        msHyphens: 'none',
        hyphens: 'none',
        padding: '1em',
        margin: '.5em 0',
        overflow: 'auto',
        background: '#1e1e1e',
    },
    'code[class*="language-"]': {
        color: '#d4d4d4',
        fontSize: 'var(--font-size-code)',
        fontWeight: 'var(--font-weight-normal)',
        letterSpacing: '0',
        lineHeight: '1.25rem',
        textShadow: 'none',
        fontFamily: 'var(--font-font-family-code), monospace',
        direction: 'ltr',
        textAlign: 'left',
        whiteSpace: 'pre',
        wordSpacing: 'normal',
        wordBreak: 'normal',
        MozTabSize: '4',
        OTabSize: '4',
        tabSize: '4',
        WebkitHyphens: 'none',
        MozHyphens: 'none',
        msHyphens: 'none',
        hyphens: 'none',
    },
    '.namespace': {
        opacity: '.7',
    },
    comment: {
        color: 'rgb(var(--palette-code-light-comment))',
    },
    prolog: {
        color: 'rgb(var(--palette-code-light-comment))',
    },
    punctuation: {
        color: 'rgb(var(--palette-code-light-operator))',
    },
    property: {
        color: 'rgb(var(--palette-code-light-property))',
    },
    boolean: {
        color: 'rgb(var(--palette-code-light-boolean-literal))',
    },
    number: {
        color: 'rgb(var(--palette-code-light-number-literal))',
    },
    string: {
        color: 'rgb(var(--palette-code-light-string-literal))',
    },
    char: {
        color: 'rgb(var(--palette-code-light-string-literal))',
    },
    operator: {
        color: 'rgb(var(--palette-code-light-operator))',
    },
    keyword: {
        color: 'rgb(var(--palette-code-light-keyword))',
    },
    'keyword.module': {
        color: 'rgb(var(--palette-code-light-keyword))',
    },
    'keyword.control-flow': {
        color: 'rgb(var(--palette-code-light-keyword))',
    },
    function: {
        color: 'rgb(var(--palette-code-light-function))',
    },
    'function.maybe-class-name': {
        color: 'rgb(var(--palette-code-light-function))',
    },
    regex: {
        color: 'rgb(var(--palette-code-light-operator))',
    },
    italic: {
        fontStyle: 'italic',
    },
    variable: {
        color: 'rgb(var(--palette-code-light-property))',
    },
};
export default style;
//# sourceMappingURL=ndl-code-light.js.map